<template>
  <form autocomplete="off">
    <q-field>
      <q-input
        v-model="details.requisites.tin"
        stack-label="ИНН"
      />
    </q-field>
    <q-field>
      <q-input
        v-model="details.requisites.bank_name"
        stack-label="Название банка"
      />
    </q-field>
    <q-field>
      <q-input
        v-model="details.requisites.checking_account"
        stack-label="Номер рассчетного счёта"
      />
    </q-field>

    <q-field>
      <q-input
        v-model="details.requisites.additional_info"
        stack-label="Дополнительная информация"
      />
    </q-field>
    <q-field>
      <q-input
        v-model="details.requisites.sender"
        stack-label="Отправитель счёта"
      />
    </q-field>
    <q-field>
      <q-input
        v-model="details.requisites.address"
        stack-label="Адрес"
        type="textarea"
      />
    </q-field>
    <div class="q-mt-lg row justify-end items-center">
      <div>
        <q-btn
          @click="save()"
          :loading="saving"
          label="Сохранить"
          color="primary"
        />
        <q-btn
          @click="$emit('close')"
          color="primary"
          flat
          label="Закрыть"
        />
      </div>
    </div>
  </form>
</template>

<script>
  import harvester from './mixins/harvester';

  import {
    QField,
    QInput,
    QSelect,
    QBtn,
    QUploader
  } from 'quasar';

  export default {
    name: 'InvoiceMethod',
    components: {
      QField,
      QInput,
      QBtn,
      QUploader
    },
    mixins: [
      harvester
    ],
    props: {
      details: {
        type: Object,
        default () {
          return {
            requisites: {
              tin: null,
              address: '',
              checking_account: '',
              bank_name: '',
              mfi: null,
              additional_info: '',
              sender: '',
              stamp_img_url: '',
              name_in_signature: ''
            }
          };
        }
      }
    },
    methods: {
      uploadFile (file, updateProgress) {
        let formData = new FormData(),
          config = {
            onUploadProgress: function (progressEvent) {
              updateProgress(progressEvent.loaded / progressEvent.total);
            }
          };

        formData.append('image', file);
        return new Promise((resolve, reject) => {
          this.api.post(`/payment-details/${this.details.id}`, formData, config).then(response => {
            this.details.requisites.stamp_img_url = new URL(response.data.data.path).pathname;
            resolve(file);
          }).catch(error => {
            reject(error);
            console.error(error);
          });
        });
      }
    }
  };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ServiceProviderSetting/methods/WayforpayMethod.vue